import * as React from 'react'
import MUISelect from '@mui/material/Select'

const Select = (props) => <MUISelect {...props} />

export default Select
